"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get verifyDefaultWorkspace () {
        return verifyDefaultWorkspace;
    },
    get verifyDefaultWsOwner () {
        return verifyDefaultWsOwner;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _utils = require("~/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const verifyDefaultWorkspace = async (user, ncMeta = _Noco.default.ncMeta)=>{
    // if ee do not need to handle this
    if (_utils.isEE) {
        return;
    }
    // if ws id exists, return
    if (_Noco.default.ncDefaultWorkspaceId) {
        return;
    }
    const ncDefaultWorkspaceId = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
        key: _globals.NC_STORE_DEFAULT_WORKSPACE_ID_KEY
    });
    // if store has default ws id, we use that
    if (ncDefaultWorkspaceId == null ? void 0 : ncDefaultWorkspaceId.value) {
        _Noco.default.ncDefaultWorkspaceId = ncDefaultWorkspaceId.value;
        return;
    }
    if (!user) {
        // find super user
        const superUser = await ncMeta.knexConnection(_globals.MetaTable.USERS).where('roles', 'like', '%super%').first();
        // no user created yet, we don't need to init ws
        if (!superUser) {
            return;
        }
        user = superUser;
    }
    // check if there are any records in workspace table
    let workspace = await ncMeta.knexConnection(_globals.MetaTable.WORKSPACE).orderBy('created_at', 'asc').first();
    if (!workspace) {
        // create workspace if not exists
        workspace = await ncMeta.metaInsert2(_globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.WORKSPACE, {
            title: 'Default Workspace',
            fk_user_id: user.id,
            status: 1,
            plan: 'free',
            fk_org_id: null
        });
        // insert ws user
        await ncMeta.metaInsert2(_globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.WORKSPACE_USER, {
            fk_workspace_id: workspace.id,
            fk_user_id: user.id,
            roles: _nocodbsdk.WorkspaceUserRoles.OWNER
        }, true);
    }
    // insert to store as it won't be exists
    await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
        key: _globals.NC_STORE_DEFAULT_WORKSPACE_ID_KEY,
        value: workspace.id
    }, true);
    _Noco.default.ncDefaultWorkspaceId = workspace.id;
};
const verifyDefaultWsOwner = async (ncMeta = _Noco.default.ncMeta)=>{
    // if ee do not need to handle this
    if (_utils.isEE) {
        return;
    }
    // find super user
    const user = await ncMeta.knexConnection(_globals.MetaTable.USERS).where('roles', 'like', '%super%').first();
    // no user created yet, we don't need to init ws
    if (!user) {
        return;
    }
    // if no default ws id present, we verify it first
    if (!_Noco.default.ncDefaultWorkspaceId) {
        await verifyDefaultWorkspace(user, ncMeta);
    }
    // get the user's workspace role
    const workspaceUser = await ncMeta.knexConnection(_globals.MetaTable.WORKSPACE_USER).where('fk_workspace_id', _Noco.default.ncDefaultWorkspaceId).andWhere('fk_user_id', user.id).first();
    // if no role for user, we assign owner
    if (!workspaceUser) {
        await ncMeta.metaInsert2(_globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.WORKSPACE_USER, {
            fk_workspace_id: _Noco.default.ncDefaultWorkspaceId,
            fk_user_id: user.id,
            roles: _nocodbsdk.WorkspaceUserRoles.OWNER
        }, true);
    } else if (workspaceUser.roles !== _nocodbsdk.WorkspaceUserRoles.OWNER) {
        await ncMeta.knexConnection(_globals.MetaTable.WORKSPACE).where('fk_workspace_id', _Noco.default.ncDefaultWorkspaceId).andWhere('fk_user_id', user.id).update({
            roles: _nocodbsdk.WorkspaceUserRoles.OWNER
        });
    }
};
